var React = require('react');

function Medium (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 8c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5S4.243 8 7 8M7 6c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7S10.866 6 7 6L7 6zM18 8.693c.409.582 1 2.081 1 4.307s-.591 3.725-1 4.307c-.409-.582-1-2.081-1-4.307S17.591 9.275 18 8.693M18 6.5c-1.657 0-3 2.91-3 6.5s1.343 6.5 3 6.5 3-2.91 3-6.5S19.657 6.5 18 6.5L18 6.5zM23 8A1 5 0 1023 18 1 5 0 1023 8z"}));
}

Medium.defaultProps = {"x":"0px","y":"0px","width":"48","height":"48","viewBox":"0 0 24 24"};

module.exports = Medium;

Medium.default = Medium;
